export const openLink = (link) => {
  window.open(link, "_blank");
};

export const getQueryParameter = (name) => {
  return new URLSearchParams(window.location.search).get(name);
};
